import Tabs from "./tabs";
import dropdown from "./dropdown";
import StickyBlock from "./stickyBlock";
import scrollTop from "../utils/scrollTop";

const initSearch = () => {
    const stickySearchArchive = new StickyBlock('.js-sticky-search-archive', '.js-sticky-search-archive-wrapper', 1250);

    const contactTabs =  new Tabs('.js-search-tab-link', () => {
        stickySearchArchive.destroy();
        stickySearchArchive.init();
        scrollTop();
    });

    contactTabs.init();
    stickySearchArchive.init();

    dropdown('.js-products-dropdown', (ev) => {
        filterItems(ev.currentTarget, 'products',  {'class': 'products-block__item--white'}, (response) => {
            $('.js-products-container').html(response);
        })
    });

    dropdown('.js-files-dropdown', (ev) => {
        filterItems(ev.currentTarget, 'files',  '', (response) => {
            $('.js-files-container').html(response);
        })
    });

    dropdown('.js-post-dropdown', (ev) => {
        filterItems(ev.currentTarget, 'post',  '', (response) => {
            $('.js-post-container').html(response);
        })
    });


    dropdown('.js-support-dropdown', (ev) => {
        filterItems(ev.currentTarget, 'support',  '', (response) => {
            $('.js-support-container').html(response);
        })
    });


    function filterItems(filterDropdown, postType, args,  cb) {
        let activeItem = $(filterDropdown),
            order = activeItem.data('order'),
            orderby = activeItem.data('orderby'),
            meta =  activeItem.data('meta')?  activeItem.data('meta') : 0,
            query = $('input[name=s]').val();

        let data = {
            action: 'posts_load_more',
            order: order,
            orderby: orderby,
            meta : meta,
            paged : -1,
            perPage: -1,
            postType:  postType,
            query: query,
            args: args,
        };

        $.ajax({
            type: 'POST',
            url: ajax_url[0],
            dataType: "html",
            data: data,
            success: function (response) {
                if(cb) {
                    cb(response);
                }
            },
            error: function (error) {
                console.log('error', error);
            }
        });
    }




}

export default initSearch;